// Add your JS customizations here
class Accordion {
	constructor(el) {
		// Store the <details> element
		this.el = el;
		// Store the <summary> element
		this.summary = el.querySelector("summary");
		// Store the <div class="content"> element
		this.content = el.querySelector(".accordion");

		// Store the animation object (so we can cancel it if needed)
		this.animation = null;
		// Store if the element is closing
		this.isClosing = false;
		// Store if the element is expanding
		this.isExpanding = false;
		// Detect user clicks on the summary element
		this.summary.addEventListener("click", (e) => this.onClick(e));
	}

	onClick(e) {
		// Stop default behaviour from the browser
		e.preventDefault();
		// Add an overflow on the <details> to avoid content overflowing
		this.el.style.overflow = "hidden";
		// Check if the element is being closed or is already closed
		if (this.isClosing || !this.el.open) {
			this.open();
			// Check if the element is being openned or is already open
		} else if (this.isExpanding || this.el.open) {
			this.shrink();
		}
	}

	shrink() {
		// Set the element as "being closed"
		this.isClosing = true;

		// Store the current height of the element
		const startHeight = `${this.el.offsetHeight}px`;
		// Calculate the height of the summary
		const endHeight = `${this.summary.offsetHeight}px`;

		// If there is already an animation running
		if (this.animation) {
			// Cancel the current animation
			this.animation.cancel();
		}

		// Start a WAAPI animation
		this.animation = this.el.animate(
			[
				// Set the keyframes from the startHeight to endHeight
				{ height: startHeight },
				{ height: endHeight },
			],
			{
				duration: 500, // Increased duration for smoother transition
				easing: "ease-in-out", // Ease-in-out for smoother animation
			}
		);

		// When the animation is complete, call onAnimationFinish()
		this.animation.onfinish = () => this.onAnimationFinish(false);
		// If the animation is cancelled, isClosing variable is set to false
		this.animation.oncancel = () => (this.isClosing = false);
	}

	open() {
		// Apply a fixed height on the element
		this.el.style.height = `${this.el.offsetHeight}px`;
		// Force the [open] attribute on the details element
		this.el.open = true;
		// Wait for the next frame to call the expand function
		window.requestAnimationFrame(() => this.expand());
	}

	expand() {
		// Set the element as "being expanding"
		this.isExpanding = true;
		// Get the current fixed height of the element
		const startHeight = `${this.el.offsetHeight}px`;
		// Calculate the open height of the element (summary height + content height)
		const endHeight = `${
			this.summary.offsetHeight + this.content.offsetHeight
		}px`;

		// If there is already an animation running
		if (this.animation) {
			// Cancel the current animation
			this.animation.cancel();
		}

		// Start a WAAPI animation
		this.animation = this.el.animate(
			[
				// Set the keyframes from the startHeight to endHeight
				{ height: startHeight },
				{ height: endHeight },
			],
			{
				duration: 500, // Increased duration for smoother transition
				easing: "ease-in-out", // Ease-in-out for smoother animation
			}
		);
		// When the animation is complete, call onAnimationFinish()
		this.animation.onfinish = () => this.onAnimationFinish(true);
		// If the animation is cancelled, isExpanding variable is set to false
		this.animation.oncancel = () => (this.isExpanding = false);
	}

	onAnimationFinish(open) {
		// Set the open attribute based on the parameter
		this.el.open = open;
		// Clear the stored animation
		this.animation = null;
		// Reset isClosing & isExpanding
		this.isClosing = false;
		this.isExpanding = false;
		// Remove the overflow hidden and the fixed height
		this.el.style.height = this.el.style.overflow = "";
	}
}

document.querySelectorAll("details").forEach((el) => {
	new Accordion(el);
});

(function ($) {
	/**************************************/
	/* !Tiny Carousels                    */
	/**************************************/
	if ($(".usp-carousel__carousel").length > 0) {
		/* TinySlider */
		var uspSlider = tns({
			container: ".usp-carousel__carousel",
			mouseDrag: true,
			autoplay: true,
			speed: 1000,
			autoplayTimeout: 2000,
			autoplayButtonOutput: false,
			nav: false,
			controls: false,
			responsive: {
				0: {
					items: 1,
				},
				600: {
					items: 2,
				},
				768: {
					items: 2,
				},
				992: {
					items: 3,
				},
				1200: {
					items: 4,
				},
				1400: {
					items: 4,
				},
			},
		});
	}
})(jQuery);


jQuery(function ($) {
    const breakpoint = 1200; // px
    const closeDelay = 300; // ms
    const $dropdownItems = $('.nav-item.has-children');

    function enableHoverDropdown() {
        $dropdownItems.each(function () {
            const $item = $(this);
            const $link = $item.find('.nav-link.dropdown').first();
            const $dropdownMenu = $item.find('.dropdown-menu').first();
            let closeTimer;

            if (!$link.length || !$dropdownMenu.length) return;

            // Remove Bootstrap's click toggle
            $link.removeAttr('data-bs-toggle aria-expanded');

            // Hover events with delay on leave
            $item.on('mouseenter.hoverMenu', function () {
                clearTimeout(closeTimer);
                $link.addClass('show');
                $dropdownMenu
                    .stop(true, true)
                    .fadeIn(200)
                    .addClass('show');
            }).on('mouseleave.hoverMenu', function () {
                closeTimer = setTimeout(function () {
                    $link.removeClass('show');
                    $dropdownMenu
                        .stop(true, true)
                        .fadeOut(200, function () {
                            $(this).removeClass('show');
                        });
                }, closeDelay);
            });

            // Make parent link go to its page
            $link.on('click.hoverMenu', function () {
                window.location.href = $link.attr('href');
            });

            // Ensure dropdown hidden initially
            $dropdownMenu.hide();
        });
    }

    function disableHoverDropdown() {
        $dropdownItems.each(function () {
            const $item = $(this);
            const $link = $item.find('.nav-link.dropdown').first();
            const $dropdownMenu = $item.find('.dropdown-menu').first();

            if (!$link.length || !$dropdownMenu.length) return;

            // Restore Bootstrap attributes
            $link.attr({
                'data-bs-toggle': 'dropdown',
                'aria-expanded': 'false'
            });

            // Remove hover events
            $item.off('.hoverMenu');
            $link.off('.hoverMenu');

            // Reset styles
            $link.removeClass('show');
            $dropdownMenu
                .stop(true, true)
                .removeAttr('style') // removes inline fadeIn/fadeOut styles
                .removeClass('show');
        });
    }

    function checkWidth() {
        if ($(window).width() >= breakpoint) {
            enableHoverDropdown();
        } else {
            disableHoverDropdown();
        }
    }

    checkWidth();
    $(window).on('resize', checkWidth);
});


jQuery(document).ready(function($) {
    $(document).on('click', function(e) {
        var $menu = $('.navbar-nav.ms-auto');
        var $navbarCollapse = $('.navbar-collapse');

        // Check if menu is open
        if ($navbarCollapse.hasClass('show')) {
            // If click is outside the menu and not on the navbar-toggler
            if (!$menu.is(e.target) && $menu.has(e.target).length === 0 &&
                !$('.navbar-toggler').is(e.target) && $('.navbar-toggler').has(e.target).length === 0) {
                $navbarCollapse.collapse('hide');
            }
        }
    });
});

jQuery(document).ready(function($) {
    var $mobileContacts = $('.mobile__contacts');
    var $originalParent = $mobileContacts.parent(); // Save original parent
    var $originalIndex = $mobileContacts.index();   // Save original index position

    function moveContacts() {
        if ($(window).width() <= 1200) {
            if (!$mobileContacts.parent().is('#main-menu')) {
                $('#main-menu').append($mobileContacts);
            }
        } else {
            // Move back to original position
            if ($mobileContacts.parent().is('#main-menu')) {
                if ($originalParent.children().length > $originalIndex) {
                    $originalParent.children().eq($originalIndex).before($mobileContacts);
                } else {
                    $originalParent.append($mobileContacts);
                }
            }
        }
    }

    // Run on load
    moveContacts();

    // Run on resize
    $(window).on('resize', function() {
        moveContacts();
    });
});
jQuery(document).ready(function($) {
    var $toggler = $('.navbar-toggler.inside__menu');

    if ($toggler.length) {
        $('ul#main-menu').append($toggler);
    }
});

        jQuery(function($){
        $(document).ready(function () {
            // Create the text element
            const rejectText = $('<span class="reject--text">*Reject all cookies except those essential for the running of this website.</span>');
        
            // Append the text after the button wrapper
            $('.cky-notice-btn-wrapper').after(rejectText);
        });
    });

	    jQuery(function($) {
        $(document).ready(function() {
            var stickyElement = $('#main-nav');
    
            $(window).scroll(function() {
                if ($(window).scrollTop() > 50) {
                    stickyElement.addClass('scrolled');
                } else {
                    stickyElement.removeClass('scrolled');
                }
            });
        });
    });